import template from './template.html';
import './styles.css';

controller.$inject = [];

export function controller() {
    let vm = {};
    let driverHolidays = {};
    this.$onInit = function() {
    vm = this;

    vm.id = vm.data.id;
    vm.shifts = [];

    //pull the days out of the data with the shift date (may not be one for each day of the week)
    const days = vm.data.days.map(day => {
        day.shiftDate = new Date(day.shiftDate);
        return day;
    });
    
    driverHolidays = vm.holidays && vm.holidays.map(holiday => {
        return new Date(holiday.day);
    });
    
    const weekStartDate = new Date(days[0].shiftDate);
    weekStartDate.setDate(weekStartDate.getDate()-weekStartDate.getDay());

    //create an empty shift for each day of the week
    for (var i = 0; i < 7; i++) {
        const shiftDate = new Date(weekStartDate);
        shiftDate.setDate(weekStartDate.getDate() + i);

        vm.shifts[i] = {
            shifts: [],
            shiftDate,
            driverHoliday: dayIsDriverHoliday(shiftDate)
        };
    }
    
    //assign days from data into correct vm.shifts slot
    for (var j = 0; j < days.length; j++) {
        const day = new Date(days[j].shiftDate).getDay();
        days[j].driverHoliday = vm.shifts[day].driverHoliday;
        vm.shifts[day] = days[j];
    }
}
    
    function dayIsDriverHoliday(date) {
        if( Object.prototype.toString.call( driverHolidays ) !== '[object Array]' ) return false;
        
        for (var i = 0; i < driverHolidays.length; i++) {
            if (date.toDateString() == driverHolidays[i].toDateString()) {
                return true;
            }
        }
        return false;
    }
}

export default () => ({
    template,
    controller,
    restrict: 'E',
        controllerAs: 'vm',
        bindToController: {
            data: '=',
            holidays: '='
        },
        scope: {}
});



// WEBPACK FOOTER //
// ./src/js/components/planner/week/index.js